import axiosInstance from "../helpers/axiosInstance";

const isValidParam = (value) => {
  return value !== undefined && value !== null && value !== "";
};

const getFilteredParams = (params) => {
  return Object.fromEntries(
    Object.entries(params).filter(([_, value]) => isValidParam(value))
  );
};

export const searchGetLogs = (params) => {
  const filteredParams = getFilteredParams(params);
  const queryString = new URLSearchParams(filteredParams).toString();

  return axiosInstance.get(`/logs?${queryString}`).then((response) => {
    if (response.data.status !== "Error") {
      return { ...response};
    } else {
      throw new Error(response.data.errors[0]);
    }
  });
};